import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';

import { BookOnlineContext } from '../context';

const AddCartMobile = () => {
  const { cartItems, cartTotal } = useContext(BookOnlineContext);

  return (
    <div className="AddCartMobile">
      <div className="AddCartMobile-Count">
        <p className="AddCartMobile-Count__Title">Service selected</p>
        {cartItems.length}
      </div>
      <div className="AddCartMobile-PaymentBtn">
        <Button
          block
          variant="danger"
          className="rounded-0"
        >Proceed to Checkout</Button>
      </div>
      <div className="AddCartMobile-CartTotal">
        <p className="AddCartMobile-CartTotal__Title">Total payable</p>
        ${cartTotal}
      </div>
    </div>
  );
};

export default AddCartMobile;